// Copyright (c) StrangeBee 2023

import { QuerySelector, UserTypeValues } from 'thehive-sdk';

interface ComputeListSelectorParams {
    orgId: string;
}

export const computeListSelector = ({ orgId }: ComputeListSelectorParams): QuerySelector => ({
    head: [{ name: 'getOrganisation', idOrName: orgId }, { name: 'users' }],
    options: { organisation: orgId },
    name: `get-${orgId}-users`,
    sort: ['+login'],
});

export const computeListWithoutServiceSelector = ({ orgId }: ComputeListSelectorParams): QuerySelector => {
    return {
        ...computeListSelector({ orgId }),
        ...{
            name: `get-${orgId}-normal-users`,
            initialFilters: [
                {
                    field: 'type',
                    operator: 'not',
                    values: [UserTypeValues[1]],
                    type: 'string',
                },
            ],
        },
    };
};
